'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002emath$002e$002dBig$002dInteger from "./java.math.-Big-Integer.js";
var $p;
function $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) {
  if ((!$thiz.zy)) {
    $thiz.zz = new RegExp("^[\\x00-\\x20]*([+-]?)(?:(NaN)|(Infinity)|(?:((?:(\\d+)(?:\\.(\\d*))?|\\.(\\d+))(?:[eE]([+-]?\\d+))?)|(0[xX](?:([0-9A-Fa-f]+)(?:\\.([0-9A-Fa-f]*))?|\\.([0-9A-Fa-f]+))[pP]([+-]?\\d+)))[fFdD]?)[\\x00-\\x20]*$");
    $thiz.zy = true;
  }
  return $thiz.zz;
}
export { $p_jl_Float$__parseFloatRegExp$lzycompute__O as $p_jl_Float$__parseFloatRegExp$lzycompute__O };
function $p_jl_Float$__parseFloatRegExp__O($thiz) {
  return ((!$thiz.zy) ? $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) : $thiz.zz);
}
export { $p_jl_Float$__parseFloatRegExp__O as $p_jl_Float$__parseFloatRegExp__O };
function $p_jl_Float$__parseFloatDecimal__T__T__T__T__F($thiz, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr) {
  var z0 = (+parseFloat(fullNumberStr));
  var z = Math.fround(z0);
  var zDouble = z;
  if ((zDouble === z0)) {
    return z;
  } else if ((zDouble === Infinity)) {
    return ((z0 === 3.4028235677973366E38) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, 3.4028234663852886E38, z, 3.4028235677973366E38) : z);
  } else if ((zDouble < z0)) {
    var zUp = $j_java$002elang$002e$002dObject.$m_jl_Math$().Wj(z);
    var mid$2 = (0.5 * (zDouble + zUp));
    return ((z0 === mid$2) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, z, zUp, mid$2) : z);
  } else {
    var zDown = $j_java$002elang$002e$002dObject.$m_jl_Math$().Wi(z);
    var mid$3 = (0.5 * (zDouble + zDown));
    return ((z0 === mid$3) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, z, mid$3) : z);
  }
}
export { $p_jl_Float$__parseFloatDecimal__T__T__T__T__F as $p_jl_Float$__parseFloatDecimal__T__T__T__T__F };
function $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, zUp, mid) {
  var f = $j_java$002emath$002e$002dBig$002dInteger.$ct_Ljava_math_BigInteger__T__(new $j_java$002emath$002e$002dBig$002dInteger.$c_Ljava_math_BigInteger(), (("" + integralPartStr) + fractionalPartStr));
  var e = (($j_java$002elang$002e$002dObject.$m_jl_Integer$().ez(exponentStr, 10, 214748364) - fractionalPartStr.length) | 0);
  var fpBitsDataView = $j_java$002elang$002e$002dObject.$fpBitsDataView;
  fpBitsDataView.setFloat64(0, mid, true);
  var lo = (fpBitsDataView.getInt32(0, true) | 0);
  var hi = (fpBitsDataView.getInt32(4, true) | 0);
  var lo$1 = (hi >> 20);
  if ((lo$1 === 0)) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_AssertionError(("parseFloatCorrection was given a subnormal mid: " + mid));
  }
  var hi$2 = (1048575 & hi);
  var hi$3 = (1048576 | hi$2);
  var m = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().ed(lo, hi$3);
  var k = ((lo$1 - 1075) | 0);
  if ((e >= 0)) {
    if ((k >= 0)) {
      var x = f.dv($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().gP.iu(e));
      var y = m.fZ(k);
      var cmp = x.jl(y);
    } else {
      var v = f.dv($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().gP.iu(e));
      var e$1 = ((-k) | 0);
      var cmp = v.fZ(e$1).jl(m);
    }
  } else if ((k >= 0)) {
    var e$2 = ((-e) | 0);
    var cmp = f.jl(m.dv($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().gP.iu(e$2)).fZ(k));
  } else {
    var x$2 = f.fZ(((-k) | 0));
    var e$4 = ((-e) | 0);
    var y$2 = m.dv($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().gP.iu(e$4));
    var cmp = x$2.jl(y$2);
  }
  return ((cmp < 0) ? zDown : ((cmp > 0) ? zUp : (((1 & $j_java$002elang$002e$002dObject.$floatToBits(zDown)) === 0) ? zDown : zUp)));
}
export { $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F as $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F };
function $p_jl_Float$__parseFloatHexadecimal__T__T__T__F($thiz, integralPartStr, fractionalPartStr, binaryExpStr) {
  return Math.fround($j_java$002elang$002e$002dObject.$m_jl_Double$().PS(integralPartStr, fractionalPartStr, binaryExpStr, 7));
}
export { $p_jl_Float$__parseFloatHexadecimal__T__T__T__F as $p_jl_Float$__parseFloatHexadecimal__T__T__T__F };
/** @constructor */
function $c_jl_Float$() {
  this.zz = null;
  this.zy = false;
}
export { $c_jl_Float$ as $c_jl_Float$ };
$p = $c_jl_Float$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_jl_Float$;
/** @constructor */
function $h_jl_Float$() {
}
export { $h_jl_Float$ as $h_jl_Float$ };
$h_jl_Float$.prototype = $p;
$p.PR = (function(s) {
  var groups = $p_jl_Float$__parseFloatRegExp__O(this).exec(s);
  if ((groups === null)) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
  }
  if ((groups[2] !== (void 0))) {
    var absResult = (NaN);
  } else if ((groups[3] !== (void 0))) {
    var absResult = Infinity;
  } else if ((groups[4] !== (void 0))) {
    var $x_1 = groups[4];
    var x$4 = groups[5];
    var x$5 = groups[6];
    var x$6 = groups[7];
    var x$7 = groups[8];
    var absResult = $p_jl_Float$__parseFloatDecimal__T__T__T__T__F(this, $x_1, ((x$4 !== (void 0)) ? x$4 : ""), (("" + ((x$5 !== (void 0)) ? x$5 : "")) + ((x$6 !== (void 0)) ? x$6 : "")), ((x$7 !== (void 0)) ? x$7 : "0"));
  } else {
    var x$8 = groups[10];
    var x$9 = groups[11];
    var x$10 = groups[12];
    var absResult = $p_jl_Float$__parseFloatHexadecimal__T__T__T__F(this, ((x$8 !== (void 0)) ? x$8 : ""), (("" + ((x$9 !== (void 0)) ? x$9 : "")) + ((x$10 !== (void 0)) ? x$10 : "")), groups[13]);
  }
  return ((groups[1] === "-") ? Math.fround((-absResult)) : absResult);
});
var $d_jl_Float$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_jl_Float$, "java.lang.Float$", ({
  k9: 1,
  a: 1
}));
export { $d_jl_Float$ as $d_jl_Float$ };
var $n_jl_Float$;
function $m_jl_Float$() {
  if ((!$n_jl_Float$)) {
    $n_jl_Float$ = new $c_jl_Float$();
  }
  return $n_jl_Float$;
}
export { $m_jl_Float$ as $m_jl_Float$ };
